import * as types from './login.types';

export const fetchLoginRequest = params => ({ type: types.FETCH_LOGIN_REQUEST, params });
export const fetchLoginSuccess = data => ({ type: types.FETCH_LOGIN_SUCCESS, data });
export const fetchLoginFailure = error => ({ type: types.FETCH_LOGIN_FAILURE, error });

export const fetchRefreshTokenRequest = params => ({ type: types.FETCH_REFRESH_TOKEN_REQUEST, params });
export const fetchRefreshTokenSuccess = data => ({ type: types.FETCH_REFRESH_TOKEN_SUCCESS, data });
export const fetchRefreshTokenFailure = error => ({ type: types.FETCH_REFRESH_TOKEN_FAILURE, error });
